import ReceiptServiceOrderInvoice from './ReceiptServiceOrderInvoice';

export default ReceiptServiceOrderInvoice;